import { useMutation } from '@tanstack/react-query'
import { useToast } from '@/shad/ui/toast/use-toast'
import { parseRequestError } from '@/app/common/utilities'
import { getAccessTokenPreview } from '@/queries/providers/requests'
import { ENV } from '@/app/common/constants'

interface UsePreviewTokenOptions {
  onSuccess?: (token: string) => void
  onError?: (error: Error) => void
}

export const useGeneratePreviewToken = ({
  onSuccess,
  onError,
}: UsePreviewTokenOptions = {}) => {
  const { toast } = useToast()

  return useMutation({
    mutationFn: async ({
      programId,
      providerId,
    }: {
      programId: number
      providerId: string
    }) => {
      const { token } = await getAccessTokenPreview(programId, providerId)
      return token
    },
    onSuccess: (token) => {
      const previewUrl = `${ENV.VITE_ACCESS_MARKETPLACE_PREVIEW_URL}/marketplace-preview?token=${token}`
      window.open(previewUrl, '_blank')
      onSuccess?.(token)
    },
    onError: (error: Error) => {
      const errorMessage = parseRequestError(error).message
      toast({
        title: 'Preview Failed',
        description: errorMessage,
        variant: 'destructive',
      })
      onError?.(error)
    },
  })
}
